import { MediaTypes, saveFile } from 'src/utilities/saveFile';

export interface UseDownloadPdfFileProps {
  downloadUrl: string;
  filename: string;
  onError: () => void;
}
export interface UseDownloadPdfFile {
  getPDFFileFromS3: () => void;
}

export const useDownloadPdfFile = ({
  downloadUrl,
  filename,
  onError,
}: UseDownloadPdfFileProps): UseDownloadPdfFile => {
  async function getPDFFileFromS3() {
    try {
      const response = await fetch(downloadUrl);
      const data = await response.arrayBuffer();
      const pdfFilename = `${filename}.pdf`;
      saveFile(data, pdfFilename, MediaTypes.APPLICATION_PDF);
    } catch (e) {
      onError();
    }
  }
  return {
    getPDFFileFromS3,
  };
};
